import { render, staticRenderFns } from "./SuspiciousIp.vue?vue&type=template&id=90a2b56a&scoped=true"
import script from "./SuspiciousIp.vue?vue&type=script&lang=js"
export * from "./SuspiciousIp.vue?vue&type=script&lang=js"
import style0 from "./SuspiciousIp.vue?vue&type=style&index=0&id=90a2b56a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90a2b56a",
  null
  
)

export default component.exports